/* tslint:disable */
/* eslint-disable */
/**
 * Armasuisse Dashboard Web Application API
 * API definitions for Armasuisse Dashboard Web Application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ProblemDetails } from '../models';
// @ts-ignore
import { TextualItemTypeBase } from '../models';
// @ts-ignore
import { TextualItemTypeBaseResponse } from '../models';
/**
 * TextualItemTypesApi - axios parameter creator
 * @export
 */
export const TextualItemTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates new Textual Item Type and returns newly created Textual Item Type.
         * @summary Creates new Textual Item Type.
         * @param {TextualItemTypeBase} [textualItemTypeBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTextualItemType: async (textualItemTypeBase?: TextualItemTypeBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/TextualItemTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(textualItemTypeBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Textual Item Type.
         * @summary Delete Textual Item Type.
         * @param {number} entityID Textual Item Type identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextualItemType: async (entityID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('deleteTextualItemType', 'entityID', entityID)
            const localVarPath = `/TextualItemTypes/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the Textual Item Type.
         * @summary Get Textual Item Type details.
         * @param {number} entityID Textual Item Type identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTextualItemTypeDetails: async (entityID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('getTextualItemTypeDetails', 'entityID', entityID)
            const localVarPath = `/TextualItemTypes/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of Textual Item Types.
         * @summary Get list of Textual Item Types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTextualItemTypeList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/TextualItemTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Textual Item Type and returns the modified Textual Item Type.
         * @summary Edit Textual Item Type.
         * @param {number} entityID Textual Item Type identifier
         * @param {TextualItemTypeBase} [textualItemTypeBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTextualItemType: async (entityID: number, textualItemTypeBase?: TextualItemTypeBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityID' is not null or undefined
            assertParamExists('updateTextualItemType', 'entityID', entityID)
            const localVarPath = `/TextualItemTypes/{entityID}`
                .replace(`{${"entityID"}}`, encodeURIComponent(String(entityID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(textualItemTypeBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TextualItemTypesApi - functional programming interface
 * @export
 */
export const TextualItemTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TextualItemTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates new Textual Item Type and returns newly created Textual Item Type.
         * @summary Creates new Textual Item Type.
         * @param {TextualItemTypeBase} [textualItemTypeBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTextualItemType(textualItemTypeBase?: TextualItemTypeBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextualItemTypeBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTextualItemType(textualItemTypeBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete Textual Item Type.
         * @summary Delete Textual Item Type.
         * @param {number} entityID Textual Item Type identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTextualItemType(entityID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTextualItemType(entityID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the Textual Item Type.
         * @summary Get Textual Item Type details.
         * @param {number} entityID Textual Item Type identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTextualItemTypeDetails(entityID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextualItemTypeBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTextualItemTypeDetails(entityID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of Textual Item Types.
         * @summary Get list of Textual Item Types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTextualItemTypeList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TextualItemTypeBaseResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTextualItemTypeList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update Textual Item Type and returns the modified Textual Item Type.
         * @summary Edit Textual Item Type.
         * @param {number} entityID Textual Item Type identifier
         * @param {TextualItemTypeBase} [textualItemTypeBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTextualItemType(entityID: number, textualItemTypeBase?: TextualItemTypeBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextualItemTypeBaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTextualItemType(entityID, textualItemTypeBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TextualItemTypesApi - factory interface
 * @export
 */
export const TextualItemTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TextualItemTypesApiFp(configuration)
    return {
        /**
         * Creates new Textual Item Type and returns newly created Textual Item Type.
         * @summary Creates new Textual Item Type.
         * @param {TextualItemTypeBase} [textualItemTypeBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTextualItemType(textualItemTypeBase?: TextualItemTypeBase, options?: any): AxiosPromise<TextualItemTypeBaseResponse> {
            return localVarFp.addTextualItemType(textualItemTypeBase, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Textual Item Type.
         * @summary Delete Textual Item Type.
         * @param {number} entityID Textual Item Type identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTextualItemType(entityID: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTextualItemType(entityID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the Textual Item Type.
         * @summary Get Textual Item Type details.
         * @param {number} entityID Textual Item Type identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTextualItemTypeDetails(entityID: number, options?: any): AxiosPromise<TextualItemTypeBaseResponse> {
            return localVarFp.getTextualItemTypeDetails(entityID, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of Textual Item Types.
         * @summary Get list of Textual Item Types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTextualItemTypeList(options?: any): AxiosPromise<Array<TextualItemTypeBaseResponse>> {
            return localVarFp.getTextualItemTypeList(options).then((request) => request(axios, basePath));
        },
        /**
         * Update Textual Item Type and returns the modified Textual Item Type.
         * @summary Edit Textual Item Type.
         * @param {number} entityID Textual Item Type identifier
         * @param {TextualItemTypeBase} [textualItemTypeBase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTextualItemType(entityID: number, textualItemTypeBase?: TextualItemTypeBase, options?: any): AxiosPromise<TextualItemTypeBaseResponse> {
            return localVarFp.updateTextualItemType(entityID, textualItemTypeBase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TextualItemTypesApi - object-oriented interface
 * @export
 * @class TextualItemTypesApi
 * @extends {BaseAPI}
 */
export class TextualItemTypesApi extends BaseAPI {
    /**
     * Creates new Textual Item Type and returns newly created Textual Item Type.
     * @summary Creates new Textual Item Type.
     * @param {TextualItemTypeBase} [textualItemTypeBase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextualItemTypesApi
     */
    public addTextualItemType(textualItemTypeBase?: TextualItemTypeBase, options?: AxiosRequestConfig) {
        return TextualItemTypesApiFp(this.configuration).addTextualItemType(textualItemTypeBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Textual Item Type.
     * @summary Delete Textual Item Type.
     * @param {number} entityID Textual Item Type identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextualItemTypesApi
     */
    public deleteTextualItemType(entityID: number, options?: AxiosRequestConfig) {
        return TextualItemTypesApiFp(this.configuration).deleteTextualItemType(entityID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the Textual Item Type.
     * @summary Get Textual Item Type details.
     * @param {number} entityID Textual Item Type identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextualItemTypesApi
     */
    public getTextualItemTypeDetails(entityID: number, options?: AxiosRequestConfig) {
        return TextualItemTypesApiFp(this.configuration).getTextualItemTypeDetails(entityID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of Textual Item Types.
     * @summary Get list of Textual Item Types.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextualItemTypesApi
     */
    public getTextualItemTypeList(options?: AxiosRequestConfig) {
        return TextualItemTypesApiFp(this.configuration).getTextualItemTypeList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Textual Item Type and returns the modified Textual Item Type.
     * @summary Edit Textual Item Type.
     * @param {number} entityID Textual Item Type identifier
     * @param {TextualItemTypeBase} [textualItemTypeBase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextualItemTypesApi
     */
    public updateTextualItemType(entityID: number, textualItemTypeBase?: TextualItemTypeBase, options?: AxiosRequestConfig) {
        return TextualItemTypesApiFp(this.configuration).updateTextualItemType(entityID, textualItemTypeBase, options).then((request) => request(this.axios, this.basePath));
    }
}
